module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "works"
  }, _vm._l((_vm.works), function(work) {
    return _c('div', {
      staticClass: "work"
    }, [_c('div', {
      staticClass: "work__title"
    }, [_vm._v(_vm._s(work.title))]), _vm._v(" "), _c('div', {
      staticClass: "work__genre"
    }, [_vm._v(_vm._s(work.genre))]), _vm._v(" "), _c('WorkImages', {
      attrs: {
        "images": work.images
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "work__description"
    }, [_vm._v(_vm._s(work.description))]), _vm._v(" "), (!work.link) ? _c('div', {
      staticClass: "work__private"
    }, [_vm._v("# Private Project")]) : _vm._e(), _vm._v(" "), (work.link) ? _c('a', {
      staticClass: "work__link",
      attrs: {
        "href": work.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(work.link))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "work__skills skills"
    }, _vm._l((work.skills), function(skill) {
      return _c('span', {
        staticClass: "skills__skill"
      }, [_vm._v(_vm._s(skill))])
    }))], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3443cc2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Works.vue
// module id = 20
// module chunks = 0